/**
 * @generated SignedSource<<c6c2ff8ea54670bdf28cb2d5836a2794>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormResponsesQuery$variables = {
  id: string;
};
export type FormResponsesQuery$data = {
  readonly node: {
    readonly content?: {
      readonly " $fragmentSpreads": FragmentRefs<"FormResponses_content">;
    };
  } | null;
};
export type FormResponsesQuery = {
  response: FormResponsesQuery$data;
  variables: FormResponsesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  }
],
v6 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormResponsesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormResponses_content"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "FolderItem",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormResponsesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isFolderItemContent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isClosed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormQuestion",
                        "kind": "LinkedField",
                        "name": "questions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v5/*: any*/),
                                "type": "CustomField__Checkboxes",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v5/*: any*/),
                                "type": "CustomField__MultipleChoice",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormResponseConnection",
                        "kind": "LinkedField",
                        "name": "responses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "respondedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "state",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Member",
                                    "kind": "LinkedField",
                                    "name": "responder",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormResponseAnswer",
                                    "kind": "LinkedField",
                                    "name": "answers",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "questionId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "checkboxValues",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Checkboxes",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "stringValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__String",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "numericValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Numeric",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "multipleChoiceValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__MultipleChoice",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "dateValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Date",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "timeValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Time",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "dateTimeValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__DateTime",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "emailValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Email",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "phoneNumberValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__PhoneNumber",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "linkValue",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CustomValue__Link",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Form",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "PendingFile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "FolderItem",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "27a54e9f0b4c12272adab1ef09b6d794",
    "id": null,
    "metadata": {},
    "name": "FormResponsesQuery",
    "operationKind": "query",
    "text": "query FormResponsesQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on FolderItem {\n      content {\n        __typename\n        ...FormResponses_content\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment FormResponses_content on FolderItemContent {\n  __isFolderItemContent: __typename\n  ... on Form {\n    title\n    isClosed\n    questions {\n      id\n      text\n      definition {\n        __typename\n        ... on CustomField__Checkboxes {\n          id\n          options {\n            value\n            text\n          }\n        }\n        ... on CustomField__Numeric {\n          id\n        }\n        ... on CustomField__String {\n          id\n        }\n        ... on CustomField__MultipleChoice {\n          id\n          options {\n            value\n            text\n          }\n        }\n        ... on CustomField__Date {\n          id\n        }\n        ... on CustomField__Time {\n          id\n        }\n        ... on CustomField__DateTime {\n          id\n        }\n        ... on CustomField__Email {\n          id\n        }\n        ... on CustomField__PhoneNumber {\n          id\n        }\n        ... on CustomField__Link {\n          id\n        }\n        id\n      }\n    }\n    responses {\n      edges {\n        node {\n          id\n          respondedAt\n          state\n          responder {\n            name\n            id\n          }\n          answers {\n            __typename\n            id\n            questionId\n            value {\n              __typename\n              ... on CustomValue__Checkboxes {\n                checkboxValues: value\n              }\n              ... on CustomValue__String {\n                stringValue: value\n              }\n              ... on CustomValue__Numeric {\n                numericValue: value\n              }\n              ... on CustomValue__MultipleChoice {\n                multipleChoiceValue: value\n              }\n              ... on CustomValue__Date {\n                dateValue: value\n              }\n              ... on CustomValue__Time {\n                timeValue: value\n              }\n              ... on CustomValue__DateTime {\n                dateTimeValue: value\n              }\n              ... on CustomValue__Email {\n                emailValue: value\n              }\n              ... on CustomValue__PhoneNumber {\n                phoneNumberValue: value\n              }\n              ... on CustomValue__Link {\n                linkValue: value\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "274121c56f788a68b4fbf8cf63f1818d";

export default node;
